import React, { FC, useMemo } from 'react';
import Pagination from '@atlaskit/pagination';
import { PageSearchResultDTO } from '@atlassiansox/phobos-client-ts';

import { getPagesFromTotalPage } from '../utils';
import { testIds } from '../constants';

import * as styles from './styles';

type SearchActionBarProps = {
  data: PageSearchResultDTO;
  currentPage: number;
  onPageChange: any;
};

const SearchActionBar: FC<SearchActionBarProps> = ({ data, currentPage, onPageChange }) => {
  const pages = useMemo(() => getPagesFromTotalPage(data?.totalPages), [data]);
  const showPagination = (data?.totalPages ?? 0) > 1;

  return (
    <div css={styles.searchActionBarStyles}>
      {showPagination && (
        <Pagination
          testId={testIds.searchPagination}
          selectedIndex={currentPage - 1}
          pages={pages}
          onChange={onPageChange}
        />
      )}
    </div>
  );
};

export default SearchActionBar;
